import { Injectable } from '@angular/core';
import { IAgencyNotificationDto, IRecruitmentRequestsDto } from '../contracts/Dtos/irecruitment-requests-dto';
import { Api } from '../core/common/api';

@Injectable({
  providedIn: 'root',
})
export class RescruitmentService {
  constructor(private api: Api) {}
  getRecruitment() {
    return this.api.get<IRecruitmentRequestsDto[]>('Recruitment/GetRecruitment');
  }
  getNotifications() {
    return this.api.get<IAgencyNotificationDto[]>('Notifications/GetAgencyNotifications');
  }
  markNotificationAsRead(id: number) {
    return this.api.post<boolean>(`Notifications/UpdateNotification/${id}`);
  }
}
